import axios from 'axios';
import axios_instance from '../utilities/axios_instance';
import bbox from 'geojson-bbox';

const API_KEY = '94976952467899872b18ff33d2d1c941';
const Fields_WFS_Layer_Name = process.env.REACT_APP_Fields_WFS;
const Segmentations_WFS_Layer_Name = process.env.REACT_APP_Segmentations_WFS;
const GEOSERVER_URL = process.env.REACT_APP_GEOSERVER_URL;

const GeoService = {
  
  getWFS: async (extent, layer_name, org_id) => {
    const lyr = layer_name === "fields" ? Fields_WFS_Layer_Name : Segmentations_WFS_Layer_Name;
    try {
      const URL = `${GEOSERVER_URL}/geoserver/wfs?service=WFS&` +
                'version=1.1.0&request=GetFeature&typename='+lyr+'&viewparams=organizationId:'+ org_id +'&'+ 
                'outputFormat=application/json&srsname=EPSG:4326&' +
                'bbox=' +
                extent.join(',') +
                ',EPSG:4326';

      const response = await axios_instance.get(`${URL}`);
      
      let data = "";
      if(!response.data.features) {
       
        data = {
          "type": "FeatureCollection",
          "features": [],
          "totalFeatures": 0,
          "numberMatched": 0,
          "numberReturned": 0,
          "crs": null
        }
      } else {
     
        data = response.data
      }
      
      return data;
    } catch (error) {
      console.error(error);
    }
  },

  getRegions: async (extent, zoom_level, signal) => {
    try {
      let URL = `${process.env.REACT_APP_GEOSERVER_OLD_URL}/geoserver/wfs?service=WFS&version=1.1.0&request=GetFeature&`
      URL += "typename=Fieldops%3ARegions&"
      URL += "outputFormat=application%2Fjson&srsname=EPSG%3A4326&"
      URL += `bbox=${extent.join(',')},EPSG:4326&viewparams=zoomLevel:${zoom_level}`;
      
      const response = await axios_instance.get(`${URL}`, { signal });
      
      return response.data;
    } catch (error) {
      if (signal?.aborted || axios.isCancel(error)) return;
      console.error(error);
    }
  },

  segmentBBOX: async (geo) => { //geo is a geojson feature, coming from EditControl of react-leaflet-draw
    const _bbox = bbox(geo);
    const extent = _bbox.join(",");
    console.log("EXTENT: ", extent, "BBOX: ", bbox(geo), "GEO: ", geo);
    try {
        const segment_response = await axios_instance.post(`/field/segment?bbox=${extent}`, {});
        const segment_data = segment_response.data;
        console.log("SEG DATA: ", segment_data);
        return segment_data.data.id;
    } catch (error ){
        console.error(error);
    }
  },
  getSegmentation: async (id) => { //geo is a geojson feature, coming from EditControl of react-leaflet-draw
    try {
        const segment_response = await axios_instance.get(`/field/segment/${id}`);
        const segment_data = segment_response.data;
        return segment_data.data;
    } catch (error ){
        console.error(error);
    }
  },
  getSegmentationProgresses: async() => {
    const _classifications = JSON.parse(localStorage.getItem("Segmentations"));
    for (var i = 0; i<_classifications.length; i++) {
      var cls = _classifications[i];
      const resp = await GeoService.getSegmentation(cls.id);
      console.log("RESP: ", resp);
      _classifications[i] = {id: cls.id, name: cls.name, geo_coord:resp.field.bbox?.coordinates/* cls.geo.features[0].geometry.coordinates*/, createdAt: resp.field.createdAt, coordinates: resp.field.bbox?.coordinates}
    }

    localStorage.setItem("Segmentations", JSON.stringify(_classifications));
    return _classifications;
  }

};

export default GeoService;
